import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import restrictEmoji from 'utils/restrictEmoji';
import InputRow from 'components/IncorporationOfTerms/Register/FormAtoms/InputRow';
import TextRow from 'components/IncorporationOfTerms/Register/FormAtoms/TextRow';

export const NameForm = ({ isAdmin, disabled, snm, gnm, fnm }) => {
  const { setValue } = useFormContext();
  useEffect(() => {
    if (snm) setValue('snm', snm);
    if (gnm) setValue('gnm', gnm);
    if (fnm) setValue('fnm', fnm);
  }, [snm, gnm, fnm]);

  return (
    <>
      {snm ? (
        <TextRow header={isAdmin ? 'MB_T_ADMIN_SNM' : 'MB_T_SNM'} isRequired>
          {snm}
        </TextRow>
      ) : (
        <InputRow
          name="snm"
          header={isAdmin ? 'MB_T_ADMIN_SNM' : 'MB_T_SNM'}
          isRequired
          disabled={disabled}
          placeholderLabel={isAdmin ? 'MB_T_ADMIN_SNM_HOLDER' : 'MB_T_SNM_HOLDER'}
          restrictCallback={restrictEmoji}
        />
      )}
      {gnm ? (
        <TextRow header={isAdmin ? 'MB_T_ADMIN_GNM' : 'MB_T_GNM'} isRequired>
          {gnm}
        </TextRow>
      ) : (
        <InputRow
          name="gnm"
          header={isAdmin ? 'MB_T_ADMIN_GNM' : 'MB_T_GNM'}
          isRequired
          disabled={disabled}
          placeholderLabel={isAdmin ? 'MB_T_ADMIN_NM_HOLDER' : 'MB_T_NM_HOLDER'}
          restrictCallback={restrictEmoji}
        />
      )}
      {fnm && (
        <TextRow header="MB_T_FNM" isRequired>
          {fnm}
        </TextRow>
      )}
    </>
  );
};
NameForm.propTypes = {
  isAdmin: PropTypes.bool,
  disabled: PropTypes.bool,
  snm: PropTypes.string,
  gnm: PropTypes.string,
  fnm: PropTypes.string,
};
NameForm.defaultProps = { isAdmin: false, disabled: false, snm: undefined, gnm: undefined, fnm: undefined };
export default NameForm;
